<template>
    <div>
        <router-view :key="this.$route.params.id" v-wechat-title="$route.meta.title" style="height: 100%"></router-view>
        <Protocol/>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {getWSUrl} from "@/config"
    import moment from "moment"
    import Protocol from "@/components/Protocol"

    export default {
        components: {Protocol},
        data() {
            return {
                websocket: null,
                timer: null,
                viewReload: null,
                innerHeight: 0
            };
        },
        computed: {
            ...mapGetters({userInfo: 'global/userInfo'})
        },
        watch: {
            'userInfo.username'(name) {
                this.initWebSocket(name)
            }
        },
        mounted() {
            window.addEventListener('hashchange', (e) => {
                let currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
            // this.listenerFocus();
            // this.listenerFocusBack();
            this.getLocation();
        },
        created() {
        },
        methods: {
            getLocation() {
                this.$store.dispatch({type: 'wechat/getLocation'})
                setTimeout(this.getLocation, 5 * 60 * 1000)
            },
            initWebSocket(username) {
                clearInterval(this.viewReload);
                clearInterval(this.timer);
                const This = this
                if (username) {
                    //初始化weosocket
                    this.websocket = new WebSocket(getWSUrl(username));
                    this.websocket.onopen = this.websocketopen;
                    this.websocket.onerror = this.websocketerror;
                    this.websocket.onmessage = this.websocketonmessage;
                    this.websocket.onclose = this.websocketclose;
                    this.timer = setInterval(() => {
                        This.websocket.send("ping");
                    }, 5000)
                } else {
                    console.error('未取到名字', username)
                    this.viewReload = setTimeout(() => {
                        This.initWebSocket()
                    }, 500)
                }
            },
            websocketopen() {
                console.log("WebSocket连接成功");
            },
            websocketonmessage(e) {
                if (e.data === "pong") return;
                const ws = JSON.parse(e.data)
                const {type} = ws
                const messageData = JSON.parse(ws.data)
                const time = moment(Number(ws.timestamp)).format('HH:mm:ss')
                // console.error('timestamp', time)

                switch (type) {
                    case "DeviceShadow":
                        // console.error('设备属性变更',messageData)
                        break;
                    case "DeviceState":
                        console.error('设备状态变更', messageData)
                        break;
                    case "Alarm":
                        this.$dialog
                            .alert({
                                title: "告警通知",
                                message: messageData.content + '  ' + time,
                                showCancelButton: true,
                                confirmButtonText: "查看",
                                cancelButtonText: "取消"
                            })
                            .then(() => {
                                this.$router.push("/device/detail/" + messageData.deviceId);
                            });
                        break;
                    case "Install":
                        this.$dialog
                            .alert({
                                title: "报装通知",
                                message: messageData.content + '  ' + time,
                                showCancelButton: true,
                                confirmButtonText: "查看",
                                cancelButtonText: "取消"
                            })
                            .then(() => {
                                this.$router.push("/device/detail/" + messageData.deviceId);
                            });
                        break;
                    case "RecoverAlarm":// 告警恢复
                        break
                    case "WebSocketState":// 推送状态
                        break;
                    default:
                        console.error('未处理推送', type, messageData,)

                }
            },
            websocketclose() {
                //关闭
                console.error("WebSocket关闭");
            },
            websocketerror() {
                //失败
                console.error("WebSocket连接失败");
            },
            listenerFocus() {
                window.addEventListener("focusin", (e) => {

                    // 软键盘弹起事件
                    console.log("键盘呼出", e);
                });
                window.addEventListener("focusout", (e) => {
                    // 软键盘关闭事件
                    console.log("键盘关闭", e);
                    window.scrollTo(0, 0);
                    // clearTimeout(myFunction);
                    // myFunction = setTimeout(function() {
                    //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // 重点  =======当键盘收起的时候让页面回到原始位置
                    // }, 200);
                });
            },
            listenerFocusBack() {
                // window.history.pushState(null, null, "#");
                // window.addEventListener("popstate", function(e) {
                //   console.info("监听返回", e.target.location.href);
                //   window.history.pushState(null, null, "#");
                //   // window.location.href = e.target.location.href;
                // });
            }
        }
    };
</script>
<style lang="less">
    @import "./assets/style/index.less";
</style>
